import { render, staticRenderFns } from "./X-modale-infos-chantier-reno.vue?vue&type=template&id=55bf22ec&scoped=true"
import script from "./X-modale-infos-chantier-reno.vue?vue&type=script&lang=js"
export * from "./X-modale-infos-chantier-reno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf22ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55bf22ec')) {
      api.createRecord('55bf22ec', component.options)
    } else {
      api.reload('55bf22ec', component.options)
    }
    module.hot.accept("./X-modale-infos-chantier-reno.vue?vue&type=template&id=55bf22ec&scoped=true", function () {
      api.rerender('55bf22ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chantier/info_chantier/X-modale-infos-chantier-reno.vue"
export default component.exports